export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.woff?1069ea55beaa0106030287c659732543";